<template>
  <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5" style="grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));">
    <slot />
  </div>
</template>
